'use client'

import { useContext } from 'react'

import { Divider } from '@vinted/web-ui'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import { ErrorItem } from '@marketplace-web/core-api/api-client-util'
import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'
import {
  PhoneRequirement,
  ShippingContactType,
} from '@marketplace-web/shipping/shipping-contact-data'

import ShippingContact from '../../../ShippingContact'

type Props = {
  transactionId?: number | null
  userSide?: TransactionSide | null
  type: ShippingContactType
  error: ErrorItem | null
  onClick: () => void
}

const GenerateShippingLabelShippingContact = ({
  transactionId,
  userSide,
  type,
  error,
  onClick,
}: Props) => {
  const {
    state: {
      labelOptions: { labelOptions, labelOptionsRewrite },
    },
  } = useContext(GetShippingLabelContext)

  const labelOptionsData = labelOptionsRewrite ?? labelOptions

  if (!userSide) return null

  const isShippingContactDisabled =
    !labelOptionsData?.sender.phoneNumberRequirement ||
    labelOptionsData?.sender.phoneNumberRequirement === PhoneRequirement.Disabled

  const phoneNumber = labelOptionsData?.sender.phoneNumber
  const phoneRequirement = labelOptionsData?.sender.phoneNumberRequirement
  const isShippingContactCompleted = !(
    phoneRequirement === PhoneRequirement.Mandatory && !phoneNumber
  )
  if (isShippingContactDisabled || !phoneRequirement || !transactionId) return null

  return (
    <>
      <ShippingContact
        type={type}
        translationPrefix={`shipping_contact.${userSide}.${type}`}
        phoneNumber={phoneNumber}
        phoneRequirement={phoneRequirement}
        transactionId={transactionId}
        isDisabled={isShippingContactDisabled}
        isCompleted={isShippingContactCompleted}
        error={error}
        onClick={onClick}
      />
      <Divider />
    </>
  )
}

export default GenerateShippingLabelShippingContact
